import { action } from 'easy-peasy';
import initStore from '../initStore';
import { IActionReset } from '../types';

const reset: IActionReset = action(state => {
  const { items, itemsPagination } = initStore;

  state.items = items;
  state.itemsPagination = itemsPagination;
});

export default reset;
